import { combineReducers } from "redux";

// REDUCERS
import user from "./user";

export default combineReducers({
  user
});
